import { useTranslation } from 'react-i18next';

// The sample verdict uses the platform's own analysis fixture (bugcheck 0x9F),
// so the card shows the real field set instead of an invented screen.
const SAMPLE_BUGCHECK = '0x9F';
const SAMPLE_BUGCHECK_NAME = 'DRIVER_POWER_STATE_FAILURE';
const SAMPLE_MODULE = 'nvlddmkm.sys';

/**
 * A card-sized preview of one analysis result.
 *
 * Two surfaces show it — the landing page's hero and the sign-in page's brand
 * panel — because both have to answer "what is this thing?" with the product
 * itself. It is the same fixture in both, so the card is one component rather
 * than two drawings of the same screen. Styles are `.verdict-panel*`.
 */
export function VerdictPreview() {
  const { t } = useTranslation();

  return (
    <div className="verdict-panel">
      <div className="verdict-panel-head">
        <span>{t('event_detail.ai_verdict')}</span>
        <span className="verdict-panel-tag">{t('welcome.example_label')}</span>
      </div>
      <div className="verdict-panel-body">
        <div className="verdict-panel-code">{SAMPLE_BUGCHECK}</div>
        <div className="verdict-panel-name">{SAMPLE_BUGCHECK_NAME}</div>
        <div className="verdict-panel-title">{t('welcome.example_title')}</div>
        <dl className="verdict-panel-rows">
          <div className="verdict-panel-row">
            <dt>{t('welcome.example_cause_label')}</dt>
            <dd>{t('welcome.example_cause')}</dd>
          </div>
          <div className="verdict-panel-row">
            <dt>{t('event_detail.faulting_module')}</dt>
            <dd className="verdict-panel-mono">{SAMPLE_MODULE}</dd>
          </div>
        </dl>
      </div>
    </div>
  );
}
